import { User, Video, Home, Monitor } from "lucide-react";
export var TourTypeOptions = [
    {
        value: "0",
        label: "Guided Tour",
        description: "In-person tour with a leasing agent",
        icon: User,
    },
    {
        value: "1",
        label: "Self-Guided Tour",
        description: "Self-directed tour of a specific unit",
        icon: Home,
    },
    {
        value: "2",
        label: "Live Video Tour",
        description: "Virtual tour with a leasing agent",
        icon: Video,
    },
    {
        value: "3",
        label: "Virtual Tour",
        description: "360° or video tour of the property",
        icon: Monitor,
    },
];
